import { useState, useEffect, useRef } from "react";

type UseIdleTimerOptions = {
    timeout?: number;
    events: Array<keyof DocumentEventMap>;
    onIdle?: () => void;
};

const useIdleTimer = ({ timeout = 60000, events, onIdle }: UseIdleTimerOptions) => {
    const [isOn, setIsOn] = useState(false);

    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    // const intervalRef = useRef<NodeJS.Timeout | null>(null);
    const lastInteractionTimeRef = useRef<number>(Date.now());

    const clear = () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        // if (intervalRef.current) clearTimeout(intervalRef.current);
    }

    const start = () => {
        clear();
        lastInteractionTimeRef.current = Date.now();

        // intervalRef.current = setInterval(() =>
        //     console.debug(new Date(Date.now() - lastInteractionTimeRef.current).getSeconds())
        // , 1000);
        timeoutRef.current = setTimeout(() => {
            if (onIdle) onIdle();
        }, timeout);
    };

    const init = () => {
        if (isOn) return;
        events.forEach((event) => window.addEventListener(event, start));
        start();
        setIsOn(true);
    }

    const off = () =>{
        setIsOn(false);
        clear();
        events.forEach((event) =>
            window.removeEventListener(event, start)
        );
    }


    useEffect(() => {
        if (!isOn) return;
        start();
    }, [timeout]);

    return {
        init,
        off,
        isOn,
    };
};

export default useIdleTimer;
